import { useTheme } from '@emotion/react';
import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

function getStyles(name, rolSelect, theme) {
    return {
        fontWeight: rolSelect.includes(name)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
    };
}

export const SelectorRoles = ({ roles, setRoles, rolSelect, setRolSelect }) => {

    const theme = useTheme();
    const [tempRoles, setTempEmpleados] = useState([])


    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setRolSelect(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    return (
        <Grid item xs={12}>
            <FormControl sx={{ mt: 2, width: '100%' }}>
                <InputLabel id="demo-multiple-name-label">Roles permitidos</InputLabel>
                <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    value={rolSelect}
                    onChange={handleChange}
                    input={<OutlinedInput label="Roles permitidos" />}
                    MenuProps={MenuProps}
                >
                    {roles.map((rol) => (
                        <MenuItem
                            key={rol.id}
                            value={rol.id}
                            style={getStyles(rol.nombre, rolSelect, theme)}
                            onClick={() => tempRoles.push(rol)}
                        >
                            {rol.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    )
}
